import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, SnackbarActions } from 'actionsets'
import StyleSheet, { AppStyles } from 'styles'
import { Link } from 'react-router-dom'
import { CenteredCard } from 'components'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import {eventKeyMatches, KEYS} from 'utils'
import {connectQueryString} from 'containers/shared'

export class ResendInvitation extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  setEmail = ({target: { value: email}}) => {
    this.setState({email})
  }

  submit = async () => {
    await this.actions.resendInvitation(this.props.filter)
    this.actions.snackbar.show("Request Sent")
    this.props.history.push('/confirmation_resent')
  }

  renderError = () =>
    <Typography variant='body2' className={styles.error}>
      {this.props.error.title}
    </Typography>

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.submit()}>
        <Typography variant='h6'>You've already been invited!</Typography>
        <Typography variant='body2'>Please follow the sign up link from your invitation email - we sent it to {this.props.filter.email}</Typography>
        <Typography variant='body1'>Can't find it? Click below to resend it</Typography>
      </CardContent>
      <CardActions className={styles.actions}>
        <div className={styles.flexLine}>
          <Button fullWidth className={styles.button} variant='contained' color="primary" onClick={this.submit}>Resend Invitation</Button>
        </div>
      </CardActions>
      <div className={styles.flexLine} style={{padding: 16}}>
        <Link className={[AppStyles.link, styles.navBeneath].join(' ')} to='/tokens/sign_in'>Sign In | &nbsp;</Link>
        <Link className={[AppStyles.link, styles.navBeneath].join(' ')} to='/tokens/sign_up'>Sign Up</Link>
      </div>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: '#EA5142'
  },
  button:{
  },
  card: {
    padding: 15,
    paddingBottom: 50
  },
  flexLine: {
    width: '100%',
    flex: '1 0 100%',
    marginLeft: 0,
    marginRight: 0
  },
  actions: {
    flexWrap: 'wrap',
    justifyContent: 'end',
    paddingLeft: 16,
    paddingRight: 16,
  },
  navBeneath: {
    color: '#b9b39b',
    fontSize: 14,
    marginTop: 15,
    textAlign: 'center',
    width: '100%'
  }
})

export default connect(({tokens}) => tokens)(connectQueryString(ResendInvitation))